import { excuseApi } from '../commons/http';

/**
 * Get weekly schedule with duty_types included in response
 * Response format: { duty_types: [...], staff_schedules: [...] }
 */
export const getWeeklySchedule = async (startDate, endDate) => {
  const res = await excuseApi({
    path: '/work-schedules/weekly',
    method: 'GET',
    params: { start_date: startDate, end_date: endDate }
  });
  return res.data;
};

/**
 * Get current user's schedule
 */
export const getMySchedule = async (startDate, endDate) => {
  const res = await excuseApi({
    path: '/work-schedules/my-schedule',
    method: 'GET',
    params: { start_date: startDate, end_date: endDate }
  });
  return res.data;
};

/**
 * Get work schedules with filters
 */
export const getWorkSchedules = async (params) => {
  const res = await excuseApi({
    path: '/work-schedules',
    method: 'GET',
    params
  });
  return res.data;
};

/**
 * Get single work schedule by ID
 */
export const getWorkSchedule = async (id) => {
  const res = await excuseApi({
    path: `/work-schedules/${id}`,
    method: 'GET'
  });
  return res.data;
};

/**
 * Create single schedule entry
 * @param {Object} data - { account_id, schedule_date, shift, duty_type_id }
 */
export const createWorkSchedule = async (data) => {
  const res = await excuseApi({
    path: '/work-schedules',
    method: 'POST',
    body: data
  });
  return res.data;
};

/**
 * Create multiple schedule entries
 * @param {Array} entries - Array of { account_id, schedule_date, shift, duty_type_id }
 */
export const createBulkWorkSchedules = async (entries) => {
  const res = await excuseApi({
    path: '/work-schedules/bulk',
    method: 'POST',
    body: { entries }
  });
  return res.data;
};

/**
 * Update schedule entry
 * @param {number} id - Schedule ID
 * @param {Object} data - { duty_type_id, account_id, schedule_date, shift }
 */
export const updateWorkSchedule = async (id, data) => {
  const res = await excuseApi({
    path: `/work-schedules/${id}`,
    method: 'PUT',
    body: data
  });
  return res.data;
};

/**
 * Delete schedule entry
 */
export const deleteWorkSchedule = async (id) => {
  const res = await excuseApi({
    path: `/work-schedules/${id}`,
    method: 'DELETE'
  });
  return res.data;
};
